export default {
  subscription: 'bronxbrewery',
  mailing_list: 22,
  info_url: 'http://landing.tavour.com/bronx/',
  title: {
    in_progress: 'Bronx Brewery Quarterly Beer Club',
    success: 'Congrats! You are Confirmed for Bronx Brewery Quarterly Beer Club',
    subtext: 'Get 16 hand-picked Bronx Brewery beers, delivered to your door.',
  },
  cancel_anytime: 'Once we email you about a quarter\'s selection, you\'ll always have at least 48 hours to let us know via ' +
  'email if you want to skip the beers. If needed, we\'ll cancel your subscription and confirm with a ' +
  'simple email. Real, beer loving people answer every email: please get in touch if you have any ' +
  'requests or questions.',
  review: {
    agreement: 'I agree to the <a href="https://www.tavour.com/terms-of-use" target="_blank">terms of use</a> ' +
    'and automatic billing.',
    summary: [
      'The Bronx Brewery Beer Club ',
      'Club pricing per box is $34.99 + $15 shipping. ',
      'We will always confirm the price ahead of time and ' +
      'let you skip any box.',
    ],
    button_text: 'Join the Club!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/bronxbrewery.js